// Captures marketing attribution (first & last touch) in localStorage.
// Runs on every landing so that leads submitted later can be attributed.

const FIRST_KEY = "mc_attr_first";
const LAST_KEY = "mc_attr_last";
const UTM_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
  "msclkid",
] as const;

export type AttrTouch = {
  utm_source?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  utm_term?: string | null;
  utm_content?: string | null;
  gclid?: string | null;
  fbclid?: string | null;
  msclkid?: string | null;
  referrer?: string | null;
  landing_page?: string | null;
  seen_at?: string;
};

function readUrlTouch(): AttrTouch {
  if (typeof window === "undefined") return {};
  const url = new URL(window.location.href);
  const touch: AttrTouch = {
    referrer: document.referrer || null,
    landing_page: url.pathname + url.search,
    seen_at: new Date().toISOString(),
  };
  let hasUtm = false;
  for (const p of UTM_PARAMS) {
    const v = url.searchParams.get(p);
    if (v) {
      (touch as Record<string, string | null>)[p] = v;
      hasUtm = true;
    }
  }
  return hasUtm || document.referrer ? touch : { ...touch };
}

export function captureAttribution() {
  if (typeof window === "undefined") return;
  try {
    const touch = readUrlTouch();
    // Always overwrite last touch
    localStorage.setItem(LAST_KEY, JSON.stringify(touch));
    // First touch only if empty
    if (!localStorage.getItem(FIRST_KEY)) {
      localStorage.setItem(FIRST_KEY, JSON.stringify(touch));
    }
  } catch {
    // ignore private-mode errors
  }
}

export function getAttribution(): { first: AttrTouch; last: AttrTouch } {
  if (typeof window === "undefined") return { first: {}, last: {} };
  try {
    const first = JSON.parse(localStorage.getItem(FIRST_KEY) || "{}");
    const last = JSON.parse(localStorage.getItem(LAST_KEY) || "{}");
    return { first, last };
  } catch {
    return { first: {}, last: {} };
  }
}
